import store from "../store/store";

export function hasAccess(accessRight: string) {
  const accessRights = (store.state as any).user.location?.accessRights ?? []
  return accessRights.find((ar: string) => ar === accessRight);
}